/**
 * Unwraps passed parameter. If the parameter is a function it is invoked with 0 parameters.
 * If it's not a function, the input value is returned.
 */ export function unwrap(input) {
    if (typeof input === 'function') {
        return unwrap(input());
    }
    return input;
}
